import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
    emptyProjectInfo,
    INxStatusProjectService,
    ProjectInfo,
    ProjectQuery,
    ProjectSummary,
    emptyProjectSummary,
    getProjectInfo,
    mapProjectsToProjectInfo,
    mapSummary,
    queryProjectKeys,
    ProjectUpdateInfo,
    exportProjects,
    exportCsv,
} from '@dat/datiq-nx-repo-utils';
import { ProjectGraph } from '@nx/devkit';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DatiqNxRepoClientStaticService implements INxStatusProjectService {
    private _http: HttpClient = inject(HttpClient);
    constructor() {}
    async exportProject(
        fileType: string,
        query: ProjectQuery,
    ): Promise<string> {
        const depGraph = await this._getGraph();
        const csvString = exportProjects(fileType, query, depGraph);

        fileType === 'csv' ? exportCsv(csvString, query) : null;

        return csvString;
    }
    async queryProjects(query: ProjectQuery): Promise<ProjectInfo[]> {
        const depGraph = await this._getGraph();

        return queryProjectKeys(query, depGraph).map((project) =>
            getProjectInfo(project, depGraph),
        );
    }

    async getProjects() {
        const depGraph = await this._getGraph();

        return mapProjectsToProjectInfo(depGraph);
    }

    private async _getGraph(): Promise<ProjectGraph> {
        try {
            const res = await lastValueFrom(
                this._http.get<{ graph: ProjectGraph }>(
                    'data/status/dep-graph.json',
                ),
            );

            return (
                res.graph ?? {
                    nodes: {},
                    dependencies: {},
                }
            );
        } catch (e) {
            console.error('Error fetching graph', e);
            return {
                nodes: {},
                dependencies: {},
            };
        }
    }

    async getProject(project: string) {
        const depGraph = await lastValueFrom(
            this._http.get<{ graph: ProjectGraph }>(
                'data/status/dep-graph.json',
            ),
        );

        return getProjectInfo(project, depGraph.graph);
    }

    async getSummary(projectKeys: string[]) {}

    async queryProjectKeys(query: ProjectQuery): Promise<string[]> {
        const depGraph = await this._getGraph();

        return queryProjectKeys(query, depGraph);
    }

    async getProjectSummary(query: ProjectQuery): Promise<ProjectSummary> {
        const depGraph = await this._getGraph();

        return mapSummary(query, depGraph);
    }

    async updateProject(
        projectKey: string,
        projectInfo: Partial<ProjectUpdateInfo>,
    ): Promise<ProjectInfo> {
        console.warn('UPDATING PROJECTS IS NOT SUPPORTED IN STATIC MODE');

        return {
            ...emptyProjectInfo,
        };
    }
}
